import React from 'react';

import { HomeCardBack } from '../home-card-back';

export interface HomeNetworkCardBackProps
  extends Readonly<{
    onButtonPress: () => void;
    style?: React.CSSProperties;
  }> {}

export const HomeNetworkCardBack = React.memo<HomeNetworkCardBackProps>((props) => {
  const { onButtonPress, style } = props;

  return (
    <HomeCardBack
      icon={'network'}
      iconColor={'tertiary'}
      empasized={'40% reduction'}
      description={'in degraded sites using AI-based closed-loop optimization'}
      title={'Ensure superior network performance'}
      onButtonPress={onButtonPress}
      style={style}
    />
  );
});
